import dayjs from 'dayjs';
import FloatingFilterSelect from '../../../../component/Common/Datagrid/Component/FloatingFilterRenderer/FloatingFilterSelect';
import { STATUS_SELECT_OPTION } from '../../../../constant/Admin/User/inputOptions';
import {
  STATUS_CODE,
  STATUS_VALUE,
} from '../../../../constant/Admin/User/standardCodes';
import { CELL_TYPE_SWITCH } from '../../../../constant/Common/DataGrid/cellType';
import datetimeComparator from '../../../Common/Datagrid/Comparator/datetimeComparator';
import generateCellRenderer from '../../../Common/Datagrid/Generator/generateCellRenderer';
import { createOptionalSelectOption } from '../../../Common/Option/Generator/selectOptionCreator';
import generateDatetimeFilters from '../../../Common/Datagrid/Generator/generateDatetimeFilters';

const createUserColumnDefs = ({
  disabledRef,
  userStatusPatchMutator,
  divList,
}) => {
  return [
    {
      headerName: 'DIV',
      width: 38,
      field: 'div',
      editable: false,
      floatingFilterComponent: FloatingFilterSelect,
      floatingFilterComponentParams: {
        option: createOptionalSelectOption({
          items: divList,
          labelKey: 'div',
          valueKey: 'div',
          isGridFilter: true,
        }),
      },
      valueGetter: gridParam => {
        const value = gridParam?.data?.userdivision_set?.default_div;
        return value;
      },
    },
    { headerName: 'AUTH', width: 130, field: 'group_name', editable: false },
    { headerName: 'USER ID', width: 72, field: 'username', editable: false },
    {
      headerName: 'FIRST NAME',
      width: 92,
      field: 'first_name',
      editable: false,
    },
    {
      headerName: 'LAST NAME',
      width: 88,
      field: 'last_name',
      editable: false,
    },
    { headerName: 'EMAIL', width: 200, field: 'email', editable: false },
    {
      headerName: 'LAST SIGN IN',
      width: 97,
      field: 'last_login',
      editable: false,
      comparator: datetimeComparator,
      cellClass: 'datetime',
      valueGetter: gridParam => {
        const value =
          gridParam?.data?.last_login &&
          dayjs(gridParam?.data?.last_login)?.isValid()
            ? dayjs(gridParam?.data?.last_login)?.format('MM/DD/YY HH:mm')
            : '';
        return value;
      },
      ...generateDatetimeFilters(),
    },
    {
      headerName: 'STATUS',
      width: 78,
      field: 'yms_status',
      editable: false,
      clickable: true,
      cellRendererSelector: gridParam => {
        return gridParam?.value !== 'WAITING'
          ? generateCellRenderer({
              gridParam,
              cellType: CELL_TYPE_SWITCH,
              value: gridParam?.data?.yms_is_active,
              onChangeHandler: ({ ...props }) => {
                if (
                  disabledRef?.current?.disabled &&
                  disabledRef?.current?.disabledRow === gridParam?.rowIndex
                ) {
                  return;
                }
                disabledRef.current.disabled = true;
                disabledRef.current.disabledRow = gridParam?.rowIndex;

                const { e, setChecked } = props;
                setChecked(!!e?.target?.checked);
                userStatusPatchMutator({ id: gridParam?.data?.id, setChecked });
              },
            })
          : null;
      },
      valueGetter: params => {
        if (params?.data?.yms_status === STATUS_VALUE?.WORKING) {
          return params?.data?.yms_is_active ? 'ACTIVATE' : 'INACTIVATE';
        }
        return STATUS_CODE?.[params?.data?.yms_status]?.label;
      },
      floatingFilterComponent: FloatingFilterSelect,
      floatingFilterComponentParams: {
        option: STATUS_SELECT_OPTION,
      },
    },
  ];
};

export default createUserColumnDefs;
